export const sortByTime = (a: any, b: any) => {
  return a.start > b.start ? 1 : a.start < b.start ? -1 : 0;
};
